import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  getCookieConsent,
  setCookieConsent,
  COOKIE_CONSENT,
} from '../../utils/cookieConsent';
import '../../assets/Helpers.css';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(() => !getCookieConsent());

  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }

    document.body.classList.add('cookie-banner-visible');
    return () => document.body.classList.remove('cookie-banner-visible');
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  const handleChoice = (consent) => {
    setCookieConsent(consent);
    setIsVisible(false);
  };

  return (
    <div className="cookie-banner" role="dialog" aria-labelledby="cookie-banner-title" aria-live="polite">
      <div className="cookie-banner__inner">
        <div className="cookie-banner__content">
          <h2 id="cookie-banner-title" className="cookie-banner__title">
            Cookie preferences
          </h2>
          <p className="cookie-banner__text">
            We use cookies to improve your experience and analyze site usage. You can accept all
            cookies or continue with essential cookies only. See our{' '}
            <Link to="/privacy" className="cookie-banner__link">
              Privacy Policy
            </Link>{' '}
            for details.
          </p>
        </div>
        <div className="cookie-banner__actions">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => handleChoice(COOKIE_CONSENT.DECLINED)}
          >
            Essential only
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => handleChoice(COOKIE_CONSENT.ACCEPTED)}
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
